<template>
    <v-app id="app">
        <component :is="layout">
            <router-view/>
        </component>
        
        <v-btn
                v-scroll="onScroll"
                v-show="fab"
                fab
                dark
                fixed
                bottom
                right
                color="primary"
                class="btn-top"
                @click="toTop"
        >
            <v-icon color="white"></v-icon>
        </v-btn>
    </v-app>
</template>

<script>
    import EmptyLayout from "@/layouts/EmptyLayout";
    import { mapGetters } from 'vuex'

    export default {
        components: {
            EmptyLayout,
        },
        data: () => ({
            fab: false
        }),

        created () {
          this.$store.dispatch('token')
        },

        computed: {
            ...mapGetters({
                userToken: 'getUserToken'
            }),

            layout() {
                return (this.$route.meta.layout || "empty") + "-layout";
            },
        },
        methods: {
            onScroll(e) {
                if (typeof window === 'undefined') return
                const top = window.pageYOffset || e.target.scrollTop || 0
                this.fab = top > 20
            },
            toTop() {
                this.$vuetify.goTo(0)
            }
        }
    }
</script>

<style>
    @import "assets/style.css";
</style>
